import {
  GET_ALL_MODULE_INFO_BY_COMPANY_ID,
  GET_ALL_STORAGE_BY_COMPANY_ID,
} from "../constants";
import { ApiCall } from "../../utils/index"

export const getStorageInfo = (cb) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.get(`/upload/checkStorageConsumption`, token);
    dispatch({
      type: GET_ALL_STORAGE_BY_COMPANY_ID,
      payload: result.data,
    });
    // cb(result.data);
  } catch (err) {
    // cb(err.response.data);
  }
};

export const getAllModuleInfo = (cb) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.get(`/company/consumption`, token);
    dispatch({
      type: GET_ALL_MODULE_INFO_BY_COMPANY_ID,
      payload: result.data,
    });
    // cb(result.data);
  } catch (err) {
    // cb(err.response.data);
  }
};
